
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes01On as ObiDiodes01OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-01-on.js';
 
 
 

 
 export const ObiDiodes01On = createComponent({
   react: React,
   tagName: 'obi-diodes-01-on',
   elementClass: ObiDiodes01OnElement,
   events: {
     
   }
  });
 
 